import { observable } from 'mobx'
import * as moment from 'moment'

export default class userSleepStore {
  @observable data = []
  @observable sessionData = []
  @observable sessionsDataByDate = []
  @observable sessionByDate = moment().format('l')
  @observable created = false
  @observable datasetId = ''

  updateData(data) {
    this.data = data
  }

  updateSessionData(data) {
    this.sessionData = data
  }

  updatesessionsDataByDate(date) {
    this.sessionsDataByDate = this.data.filter(
      d =>
        moment(new Date(d.date)).format('l') ===
        moment(new Date(date)).format('l')
    )
  }

  updatesessionsDataAfterAdd() {
    this.sessionsDataByDate = []
    this.sessionsDataByDate.push(this.sessionData)
  }

  updateSessionDataById(id) {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(id)

    this.sessionData = this.data[index]
  }

  updateCreated() {
    this.created = true
  }

  updateDataBySession() {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(this.sessionData.id)
    this.data[index] = this.sessionData
  }

  deleteSessionById(id) {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(id)

    this.data.splice(index, 1)
  }
}



// WEBPACK FOOTER //
// ./src/stores/userSleepStore.js